module.exports={
    "gestao_UsuarioModeloRelatorio": {
        "id": "gestao_UsuarioModeloRelatorio",
        "eventName": "RU_selecionar_modelo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Selecionar o tipo do modelo do relatório",
        "eventValue": "{{label}}"
    },
    "gestao_Usuario": {
        "id": "gestao_Usuario",
        "eventName": "RU_selecionar_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Selecionar o usuario para o filtro",
        "eventValue": "{{label}}"
    },
    "gestao_UsuarioStatusDespesa": {
        "id": "gestao_UsuarioStatusDespesa",
        "eventName": "RU_selecionar_status_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Selecionar o status da despesa no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_UsuarioFormaPagamento": {
        "id": "gestao_UsuarioFormaPagamento",
        "eventName": "RU_selecionar_forma_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Selecionar a forma de pagamento no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_UsuarioDataInicio": {
        "id": "gestao_UsuarioDataInicio",
        "eventName": "RU_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Data de início de filtro",
        "eventValue": 0
    },
    "gestao_UsuarioDataFinal": {
        "id": "gestao_UsuarioDataFinal",
        "eventName": "RU_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Data de término de filtro",
        "eventValue": 0
    },
    "gestao_UsuarioCodigoRelatorio": {
        "id": "gestao_UsuarioCodigoRelatorio",
        "eventName": "RU_codigo_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Codigo do relatório",
        "eventValue": 0
    },
    "gestao_UsuarioCentrosCusto": {
        "id": "gestao_UsuarioCentrosCusto",
        "eventName": "RU_selecionar_centros_custo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Selecionar o centro de custo no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_UsuarioMaisOpcoes": {
        "id": "gestao_UsuarioMaisOpcoes",
        "eventName": "RU_clique_mais_opcoes",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique para abrir mais opções",
        "eventValue": 0
    },
    "gestao_UsuarioMOResumoRelatorio": {
        "id": "gestao_UsuarioMOResumoRelatorio",
        "eventName": "RU_selecionar_mostrar_resumo_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOResumoTipoMoeda": {
        "id": "gestao_UsuarioMOResumoTipoMoeda",
        "eventName": "RU_selecionar_mostrar_resumo_tipos",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOResumoGeral": {
        "id": "gestao_UsuarioMOResumoGeral",
        "eventName": "RU_selecionar_mostrar_resumo_geral",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOResumoProjeto": {
        "id": "gestao_UsuarioMOResumoProjeto",
        "eventName": "RU_selecionar_mostrar_resumo_projeto",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOResumoReembolsavel": {
        "id": "gestao_UsuarioMOResumoReembolsavel",
        "eventName": "RU_selecionar_mostrar_resumo_reembolsavel",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMODadosBancarios": {
        "id": "gestao_UsuarioMODadosBancarios",
        "eventName": "RU_selecionar_mostrar_dados_bancarios",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarReembolsaveis": {
        "id": "gestao_UsuarioMOMostrarReembolsaveis",
        "eventName": "RU_selecionar_mostrar_reembolsaveis",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarNaoReembolsaveis": {
        "id": "gestao_UsuarioMOMostrarNaoReembolsaveis",
        "eventName": "RU_selecionar_mostrar_nao_reembolsaveis",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarDataPolitica": {
        "id": "gestao_UsuarioMOMostrarDataPolitica",
        "eventName": "RU_selecionar_mostrar_data_politicas",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarPontos": {
        "id": "gestao_UsuarioMOMostrarPontos",
        "eventName": "RU_selecionar_mostrar_pontos",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarLinkImagem": {
        "id": "gestao_UsuarioMOMostrarLinkImagem",
        "eventName": "RU_selecionar_mostrar_link_imagem",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOSomarValores": {
        "id": "gestao_UsuarioMOSomarValores",
        "eventName": "RU_selecionar_somar_valores",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarDespesasAvulsas": {
        "id": "gestao_UsuarioMOMostrarDespesasAvulsas",
        "eventName": "RU_selecionar_mostrar_despesas_avulsas",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOResumoAdiantamento": {
        "id": "gestao_UsuarioMOResumoAdiantamento",
        "eventName": "RU_selecionar_resumo_adiantamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOTaxaCambial": {
        "id": "gestao_UsuarioMOTaxaCambial",
        "eventName": "RU_selecionar_mostrar_taxa_cambial",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarImagensDespesas": {
        "id": "gestao_UsuarioMOMostrarImagensDespesas",
        "eventName": "RU_selecionar_mostrar_imagem_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOConsiderarDataAprovacao": {
        "id": "gestao_UsuarioMOConsiderarDataAprovacao",
        "eventName": "RU_selecionar_considerar_data_aprovacao",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOConsiderarDataPagamento": {
        "id": "gestao_UsuarioMOConsiderarDataPagamento",
        "eventName": "RU_selecionar_considerar_data_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOMostrarUsuarioPagina": {
        "id": "gestao_UsuarioMOMostrarUsuarioPagina",
        "eventName": "RU_selecionar_mostrar_usuario_pagina",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMOFiltrarUsuarioInativo": {
        "id": "gestao_UsuarioMOFiltrarUsuarioInativo",
        "eventName": "RU_selecionar_filtrar_usuario_inativo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioMODadosUsuarios": {
        "id": "gestao_UsuarioMODadosUsuarios",
        "eventName": "RU_selecionar_dados_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_UsuarioFiltrar": {
        "id": "gestao_UsuarioFiltrar",
        "eventName": "RU_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0
    },
    "gestao_UsuarioGerarExcel": {
        "id": "gestao_UsuarioGerarExcel",
        "eventName": "RU_gerar_excel",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_UsuarioGerarPdf": {
        "id": "gestao_UsuarioGerarPdf",
        "eventName": "RU_gerar_pdf",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_UsuarioClickDespesa": {
        "id": "gestao_UsuarioClickDespesa",
        "eventName": "RU_click_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique em qualquer despesa após o filtro para ser redirecionado",
        "eventValue": 0
    },
    "gestao_UsuarioClickIrRelatorio": {
        "id": "gestao_UsuarioClickIrRelatorio",
        "eventName": "RU_click_ir_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por usuario",
        "eventAction": "Clique no botao Ir para Relatório após ser filtrado",
        "eventValue": 0
    },
    "gestao_Projetos": {
        "id": "gestao_Projetos",
        "eventName": "RP_selecionar_projeto",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Selecionar o projeto no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_ProjetosUsuario": {
        "id": "gestao_ProjetosUsuario",
        "eventName": "RP_selecionar_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Selecionar o usuario no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_ProjetosStatusDespesa": {
        "id": "gestao_ProjetosStatusDespesa",
        "eventName": "RP_selecionar_status_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Selecionar o status da despesa no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_ProjetosDataInicio": {
        "id": "gestao_ProjetosDataInicio",
        "eventName": "RP_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Data de início de filtro",
        "eventValue": 0
    },
    "gestao_ProjetosDataFinal": {
        "id": "gestao_ProjetosDataFinal",
        "eventName": "RP_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Data de término de filtro",
        "eventValue": 0
    },
    "gestao_ProjetosCodigoRelatorio": {
        "id": "gestao_ProjetosCodigoRelatorio",
        "eventName": "RP_codigo_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Codigo do relatório",
        "eventValue": 0
    },
    "gestao_ProjetosCentrosCusto": {
        "id": "gestao_ProjetosCentrosCusto",
        "eventName": "RP_selecionar_centros_custo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Selecionar o centro de custo no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_ProjetosMaisOpcoes": {
        "id": "gestao_ProjetosMaisOpcoes",
        "eventName": "RP_clique_mais_opcoes",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique para abrir mais opções",
        "eventValue": 0
    },
    "gestao_ProjetosMOResumoTipoDespesa": {
        "id": "gestao_ProjetosMOResumoTipoDespesa",
        "eventName": "RP_selecionar_mostrar_resumo_tipos",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_ProjetosMOMostrarLinkImagem": {
        "id": "gestao_ProjetosMOMostrarLinkImagem",
        "eventName": "RP_selecionar_mostrar_link_imagem",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_ProjetosMOSomarValores": {
        "id": "gestao_ProjetosMOSomarValores",
        "eventName": "RP_selecionar_somar_valores",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_ProjetosMOMostrarImagensDespesas": {
        "id": "gestao_ProjetosMOMostrarImagensDespesas",
        "eventName": "RP_selecionar_mostrar_imagem_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_ProjetosMOConsiderarDataPagamento": {
        "id": "gestao_ProjetosMOConsiderarDataPagamento",
        "eventName": "RP_selecionar_considerar_data_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_ProjetosMOFiltrarUsuarioInativo": {
        "id": "gestao_ProjetosMOFiltrarUsuarioInativo",
        "eventName": "RP_selecionar_filtrar_usuario_inativo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_ProjetosFiltrar": {
        "id": "gestao_ProjetosFiltrar",
        "eventName": "RP_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0
    },
    "gestao_ProjetosGerarExcel": {
        "id": "gestao_ProjetosGerarExcel",
        "eventName": "RP_gerar_excel",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_ProjetosGerarPdf": {
        "id": "gestao_ProjetosGerarPdf",
        "eventName": "RP_gerar_pdf",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_ProjetosClickDespesa": {
        "id": "gestao_ProjetosClickDespesa",
        "eventName": "RP_click_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por projeto",
        "eventAction": "Clique em qualquer despesa após o filtro para ser redirecionado",
        "eventValue": 0
    },
    "gestao_ProjetosExpansiveTitle": {
        "id": "gestao_ProjetosExpansiveTitle",
        "eventName": "RT_click_titulo_tipo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique para abrir e fechar o accordion do relatorio",
        "eventValue": 0
    },
    "gestao_TiposDespesas": {
        "id": "gestao_TiposDespesas",
        "eventName": "RT_selecionar_tipo_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Selecionar o projeto no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_TiposProjetos": {
        "id": "gestao_TiposProjetos",
        "eventName": "RT_selecionar_projeto",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Selecionar o projeto no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_TiposUsuario": {
        "id": "gestao_TiposUsuario",
        "eventName": "RT_selecionar_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Selecionar o usuario no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_TiposStatusDespesa": {
        "id": "gestao_TiposStatusDespesa",
        "eventName": "RT_selecionar_status_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Selecionar o status da despesa no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_TiposDataInicio": {
        "id": "gestao_TiposDataInicio",
        "eventName": "RT_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Data de início de filtro",
        "eventValue": 0
    },
    "gestao_TiposDataFinal": {
        "id": "gestao_TiposDataFinal",
        "eventName": "RT_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Data de término de filtro",
        "eventValue": 0
    },
    "gestao_TiposCodigoRelatorio": {
        "id": "gestao_TiposCodigoRelatorio",
        "eventName": "RT_codigo_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Codigo do relatório",
        "eventValue": 0
    },
    "gestao_TiposCentrosCusto": {
        "id": "gestao_TiposCentrosCusto",
        "eventName": "RT_selecionar_centros_custo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Selecionar o centro de custo no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_TiposMaisOpcoes": {
        "id": "gestao_TiposMaisOpcoes",
        "eventName": "RT_clique_mais_opcoes",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique para abrir mais opções",
        "eventValue": 0
    },
    "gestao_TiposMOMostrarLinkImagem": {
        "id": "gestao_TiposMOMostrarLinkImagem",
        "eventName": "RT_selecionar_mostrar_link_imagem",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_TiposMOSomarValores": {
        "id": "gestao_TiposMOSomarValores",
        "eventName": "RT_selecionar_somar_valores",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_TiposMOMostrarImagensDespesas": {
        "id": "gestao_TiposMOMostrarImagensDespesas",
        "eventName": "RT_selecionar_mostrar_imagem_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_TiposMOConsiderarDataPagamento": {
        "id": "gestao_TiposMOConsiderarDataPagamento",
        "eventName": "RT_selecionar_considerar_data_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_TiposMOFiltrarUsuarioInativo": {
        "id": "gestao_TiposMOFiltrarUsuarioInativo",
        "eventName": "RT_selecionar_filtrar_usuario_inativo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_TiposFiltrar": {
        "id": "gestao_TiposFiltrar",
        "eventName": "RT_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0
    },
    "gestao_TiposGerarExcel": {
        "id": "gestao_TiposGerarExcel",
        "eventName": "RT_gerar_excel",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_TiposGerarPdf": {
        "id": "gestao_TiposGerarPdf",
        "eventName": "RT_gerar_pdf",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_TiposClickDespesa": {
        "id": "gestao_TiposClickDespesa",
        "eventName": "RT_click_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por tipos",
        "eventAction": "Clique em qualquer despesa após o filtro para ser redirecionado",
        "eventValue": 0
    },
    "gestao_CentrosCustoTipoDespesas": {
        "id": "gestao_CentrosCustoTipoDespesas",
        "eventName": "RCC_selecionar_tipo_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Selecionar o projeto no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_CentrosCustoFormaPagamento": {
        "id": "gestao_CentrosCustoFormaPagamento",
        "eventName": "RCC_selecionar_forma_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Selecionar a forma de pagamento no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_CentrosCustoUsuario": {
        "id": "gestao_CentrosCustoUsuario",
        "eventName": "RCC_selecionar_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Selecionar o usuario no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_CentrosCustoStatusDespesa": {
        "id": "gestao_CentrosCustoStatusDespesa",
        "eventName": "RCC_selecionar_status_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Selecionar o status da despesa no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_CentrosCustoDataInicio": {
        "id": "gestao_CentrosCustoDataInicio",
        "eventName": "RCC_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Data de início de filtro",
        "eventValue": 0
    },
    "gestao_CentrosCustoDataFinal": {
        "id": "gestao_CentrosCustoDataFinal",
        "eventName": "RCC_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Data de término de filtro",
        "eventValue": 0
    },
    "gestao_CentrosCustoCodigoRelatorio": {
        "id": "gestao_CentrosCustoCodigoRelatorio",
        "eventName": "RCC_codigo_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Codigo do relatório",
        "eventValue": 0
    },
    "gestao_CentrosCustoCentrosCusto": {
        "id": "gestao_CentrosCustoCentrosCusto",
        "eventName": "RCC_selecionar_centros_custo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Selecionar o centro de custo no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_CentrosCustoMaisOpcoes": {
        "id": "gestao_CentrosCustoMaisOpcoes",
        "eventName": "RCC_clique_mais_opcoes",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique para abrir mais opções",
        "eventValue": 0
    },
    "gestao_CentrosCustoMOMostrarLinkImagem": {
        "id": "gestao_CentrosCustoMOMostrarLinkImagem",
        "eventName": "RCC_selecionar_mostrar_link_imagem",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_CentrosCustoMOSomarValores": {
        "id": "gestao_CentrosCustoMOSomarValores",
        "eventName": "RCC_selecionar_somar_valores",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_CentrosCustoMOMostrarImagensDespesas": {
        "id": "gestao_CentrosCustoMOMostrarImagensDespesas",
        "eventName": "RCC_selecionar_mostrar_imagem_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_CentrosCustoMOConsiderarDataPagamento": {
        "id": "gestao_CentrosCustoMOConsiderarDataPagamento",
        "eventName": "RCC_selecionar_considerar_data_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_CentrosCustoMOFiltrarUsuarioInativo": {
        "id": "gestao_CentrosCustoMOFiltrarUsuarioInativo",
        "eventName": "RCC_selecionar_filtrar_usuario_inativo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_CentrosCustoFiltrar": {
        "id": "gestao_CentrosCustoFiltrar",
        "eventName": "RCC_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0
    },
    "gestao_CentrosCustoGerarExcel": {
        "id": "gestao_CentrosCustoGerarExcel",
        "eventName": "RCC_gerar_excel",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_CentrosCustoGerarPdf": {
        "id": "gestao_CentrosCustoGerarPdf",
        "eventName": "RCC_gerar_pdf",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_CentrosCustoClickDespesa": {
        "id": "gestao_CentrosCustoClickDespesa",
        "eventName": "RCC_click_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique em qualquer despesa após o filtro para ser redirecionado",
        "eventValue": 0
    },
    "gestao_CentrosCustoExpansiveTitle": {
        "id": "gestao_CentrosCustoExpansiveTitle",
        "eventName": "RCC_click_titulo_centro_custo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por centros de custo",
        "eventAction": "Clique para abrir e fechar o accordion do relatorio",
        "eventValue": 0
    },
    "gestao_FormaPagamentoTiposDespesas": {
        "id": "gestao_FormaPagamentoTiposDespesas",
        "eventName": "RFP_selecionar_tipo_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Selecionar o projeto no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_FormaPagamento": {
        "id": "gestao_FormaPagamento",
        "eventName": "RFP_selecionar_forma_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Selecionar a forma de pagamento no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_FormaPagamentoUsuario": {
        "id": "gestao_FormaPagamentoUsuario",
        "eventName": "RFP_selecionar_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Selecionar o usuario no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_FormaPagamentoStatusDespesa": {
        "id": "gestao_FormaPagamentoStatusDespesa",
        "eventName": "RFP_selecionar_status_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Selecionar o status da despesa no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_FormaPagamentoDataInicio": {
        "id": "gestao_FormaPagamentoDataInicio",
        "eventName": "RFP_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Data de início de filtro",
        "eventValue": 0
    },
    "gestao_FormaPagamentoDataFinal": {
        "id": "gestao_FormaPagamentoDataFinal",
        "eventName": "RFP_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Data de término de filtro",
        "eventValue": 0
    },
    "gestao_FormaPagamentoCodigoRelatorio": {
        "id": "gestao_FormaPagamentoCodigoRelatorio",
        "eventName": "RFP_codigo_relatorio",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Codigo do relatório",
        "eventValue": 0
    },
    "gestao_FormaPagamentoCentrosCusto": {
        "id": "gestao_FormaPagamentoCentrosCusto",
        "eventName": "RFP_selecionar_centros_custo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Selecionar o centro de custo no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_FormaPagamentoMaisOpcoes": {
        "id": "gestao_FormaPagamentoMaisOpcoes",
        "eventName": "RFP_clique_mais_opcoes",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique para abrir mais opções",
        "eventValue": 0
    },
    "gestao_FormaPagamentoMOMostrarLinkImagem": {
        "id": "gestao_FormaPagamentoMOMostrarLinkImagem",
        "eventName": "RFP_selecionar_mostrar_link_imagem",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_FormaPagamentoMOSomarValores": {
        "id": "gestao_FormaPagamentoMOSomarValores",
        "eventName": "RFP_selecionar_somar_valores",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_FormaPagamentoMOMostrarImagensDespesas": {
        "id": "gestao_FormaPagamentoMOMostrarImagensDespesas",
        "eventName": "RFP_selecionar_mostrar_imagem_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_FormaPagamentoMOConsiderarDataPagamento": {
        "id": "gestao_FormaPagamentoMOConsiderarDataPagamento",
        "eventName": "RFP_selecionar_considerar_data_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_FormaPagamentoMOFiltrarUsuarioInativo": {
        "id": "gestao_FormaPagamentoMOFiltrarUsuarioInativo",
        "eventName": "RFP_selecionar_filtrar_usuario_inativo",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique no checkbox ",
        "eventValue": 0
    },
    "gestao_FormaPagamentoFiltrar": {
        "id": "gestao_FormaPagamentoFiltrar",
        "eventName": "RFP_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0
    },
    "gestao_FormaPagamentoGerarExcel": {
        "id": "gestao_FormaPagamentoGerarExcel",
        "eventName": "RFP_gerar_excel",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_FormaPagamentoGerarPdf": {
        "id": "gestao_FormaPagamentoGerarPdf",
        "eventName": "RFP_gerar_pdf",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_FormaPagamentoClickDespesa": {
        "id": "gestao_FormaPagamentoClickDespesa",
        "eventName": "RFP_click_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique em qualquer despesa após o filtro para ser redirecionado",
        "eventValue": 0
    },
    "gestao_FormaPagamentoExpansiveTitle": {
        "id": "gestao_FormaPagamentoExpansiveTitle",
        "eventName": "RFP_click_titulo_forma_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Despesa por forma de pagamento",
        "eventAction": "Clique para abrir e fechar o accordion do relatorio",
        "eventValue": 0
    },
    "gestao_HorusUsuario": {
        "id": "gestao_HorusUsuario",
        "eventName": "RH_selecionar_usuario",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Selecionar o usuario no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_HorusDataInicio": {
        "id": "gestao_HorusDataInicio",
        "eventName": "RH_data_inicio",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Data de início de filtro",
        "eventValue": 0
    },
    "gestao_HorusDataFinal": {
        "id": "gestao_HorusDataFinal",
        "eventName": "RH_data_fim",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Data de término de filtro",
        "eventValue": 0
    },
    "gestao_HorusFiltro": {
        "id": "gestao_HorusFiltro",
        "eventName": "RH_selecionar_filtro",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Selecionar o filtro no dropdown",
        "eventValue": "{{label}}"
    },
    "gestao_HorusValorMinimo": {
        "id": "gestao_HorusValorMinimo",
        "eventName": "RH_valor_minimo",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Preencher o valor minimo do relatorio para o filtro",
        "eventValue": 0
    },
    "gestao_HorusValorMaximo": {
        "id": "gestao_HorusValorMaximo",
        "eventName": "RH_valor_maximo",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Preencher o valor maximo do relatorio para o filtro",
        "eventValue": 0
    },
    "gestao_HorusOrdem": {
        "id": "gestao_HorusOrdem",
        "eventName": "RH_ordenacao",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Filtro para selecionar se é ordem crescente ou decrescente ",
        "eventValue": "{{label}}"
    },
    "gestao_HorusTipo": {
        "id": "gestao_HorusTipo",
        "eventName": "RH_tipo_retorno_horus",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Filtro para selecionar o tipo de retorno do horus, sendo Ambos, Possível Duplicidade, TAG Restritiva",
        "eventValue": "{{label}}"
    },
    "gestao_HorusFiltrar": {
        "id": "gestao_HorusFiltrar",
        "eventName": "RH_filtrar_pesquisa",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Botão para filtrar os dados selecionados",
        "eventValue": 0
    },
    "gestao_HorusGerarExcel": {
        "id": "gestao_HorusGerarExcel",
        "eventName": "RH_gerar_excel",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Botão para gerar um excel do relatório",
        "eventValue": 0
    },
    "gestao_HorusClickDespesa": {
        "id": "gestao_HorusClickDespesa",
        "eventName": "RH_click_despesa",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Clique em qualquer despesa após o filtro para ser redirecionado",
        "eventValue": 0
    },
    "gestao_HorusClickImagemDespesa": {
        "id": "gestao_HorusClickImagemDespesa",
        "eventName": "RH_click_titulo_forma_pagamento",
        "eventProduct": "Gestao",
        "eventCategory": "Relatorio Horus",
        "eventAction": "Clique na imagem da despesa após o filtro",
        "eventValue": 0
    }
}